import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { OfficeTypeEnum } from '@organisms/offer/office-type-enum';

export const useOfficeOfferStore = defineStore('officeOffer', () => {
  const currentOfficeOffer = ref(window.initialAppState?.current_offer);
  const officeOffersCombinator = ref(null);
  const sameAddressOffers = ref(window.initialAppState?.same_address_offers);

  const setCurrentOfficeOffer = (newCurrentOfficeOffer) => {
    currentOfficeOffer.value = newCurrentOfficeOffer;
  };
  const setOfficeOffersCombinator = (newOfficeOffersCombinator) => {
    officeOffersCombinator.value = newOfficeOffersCombinator;
  };
  const setSameAddressOffers = (newSameAddressOffers) => {
    sameAddressOffers.value = newSameAddressOffers;
  };

  const selectedOffers = computed(() => sameAddressOffers.value?.filter((offer) => (officeOffersCombinator.value?.hashIds ?? []).includes(offer.hash_id)));
  const notSelectedOffers = computed(() => sameAddressOffers.value?.filter((offer) => !(officeOffersCombinator.value?.hashIds ?? []).includes(offer.hash_id)));

  const hasMultipleOfficeOffers = computed(() => {
    if (!officeOffersCombinator.value.offerTypes) {
      return false;
    }
    return officeOffersCombinator.value.offerTypes.length > 1;
  });

  const isUniqueOfType = (offerCode, offerType) => {
    if (!officeOffersCombinator.value.offerTypes[0]) {
      return currentOfficeOffer.value.office_type.code === offerCode && currentOfficeOffer.value.office_type.name === offerType;
    }

    const { displayOfficeType } = officeOffersCombinator.value.offerTypes[0];
    const { type } = officeOffersCombinator.value.offerTypes[0];

    if (hasMultipleOfficeOffers.value) {
      return false;
    }

    if (typeof displayOfficeType !== 'undefined' && displayOfficeType === offerCode) {
      return true;
    }

    return typeof displayOfficeType === 'undefined' && type === offerType;
  };

  const isOpenSpace = (offer) => offer.office_type?.code === OfficeTypeEnum.OPEN_SPACE;

  const selectedOffersHashIds = computed(() => selectedOffers.value?.map((offer) => offer.hash_id));
  const selectedOffersTeamSizes = computed(() => officeOffersCombinator.value?.teamSizes);
  const totalTeamSize = computed(() => officeOffersCombinator.value?.totalTeamSize);

  return {
    currentOfficeOffer,
    officeOffersCombinator,
    sameAddressOffers,
    setCurrentOfficeOffer,
    setOfficeOffersCombinator,
    setSameAddressOffers,
    selectedOffers,
    notSelectedOffers,
    hasMultipleOfficeOffers,
    isUniqueOfType,
    isOpenSpace,
    selectedOffersHashIds,
    selectedOffersTeamSizes,
    totalTeamSize,
  };
});
